import React from 'react';
import { Stack, Typography } from '@mui/material';

const PreOwnedSectionWeb = () => (
  <Stack
    sx={{
      aspectRatio: '799 / 506',
      backgroundImage: "url('assets/images/Inspection/preOwned.webp')",
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      pr: '75px',
      pl: '90px',
      justifyContent: 'center',
      mt: 10,
    }}
  >
    <Stack maxWidth="50%" spacing={24} pt={2}>
      <Stack>
        <Typography fontSize="46px" fontWeight={700} color="#FFFFFF">
          Buying a Pre-Owned Car?
        </Typography>
        <Typography fontSize="46px" fontWeight={500} mt={3} color="#FFFFFF" lineHeight="1.2">
          Drive Home with <br /> Confidence.
        </Typography>
      </Stack>
      <Typography fontSize="20px" mt={2} color="#FFFFFF" fontWeight={400} maxWidth="420px">
        Book FOCUS inspection Service and get your chosen car thoroughly inspected by certified experts—complete with
        warranty assurance.
      </Typography>
    </Stack>
  </Stack>
);

export default PreOwnedSectionWeb;
